import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  imports: [CommonModule, FormsModule],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {

  @Input() checkSize = 36;
  @Input() checkColor = '#2DADC8';
  @Input() checkBackgroundColor = '#F9F9F9';
  @Input() checkBorderColor = '#F9F9F9';
  @Input() disabled = false;

  @Input()
  get checked(): boolean {
    return this._checked;
  }

  set checked(checked: boolean) {
    if (checked !== this.checked) {
      this._checked = checked;
      this._changeDetectorRef.markForCheck();
    }
  }

  @Output() checkboxClick = new EventEmitter<boolean>();

  private _checked = false;

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  onChange = (_: boolean): void => {};

  onTouched = (): void => {};

  writeValue(value: boolean): void {
    this.checked = !!value;
    this._changeDetectorRef.markForCheck();
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this._changeDetectorRef.markForCheck();
  }

  onModelChange(event: boolean): void {
    this.checked = event;
    this.onChange(event);
    this.checkboxClick.emit();
  }
}
